import { alternateLinks, rootCanonicalUrl } from "@/config/canonical";
import { GAME_NAME, PINNED_ASSET_SLUG } from "@/config/game";
import { cn } from "@/lib/utils";
import MetaRatingComparison from "@/pages/MetaRatingLandingPage/components/MetaRatingComparison";
import MetaRatingInfoBanner from "@/pages/MetaRatingLandingPage/components/MetaRatingInfoBanner";
import { BREAKPOINTS } from "@/settings";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "usehooks-ts";

const MetaRatingLandingPage = () => {
  const { t } = useTranslation("metaRating");
  const isTouch = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <div className="relative bg-panel-base">
      <Helmet>
        <title>{t("helmet.title", { game: GAME_NAME })}</title>
        <link rel="canonical" href={rootCanonicalUrl("/meta-rating")} />
        {alternateLinks(rootCanonicalUrl("/meta-rating"))}
        <meta
          name="description"
          content={t("helmet.description", { game: GAME_NAME })}
        />
      </Helmet>

      {isTouch ? (
        <div className="relative w-full h-[312px]">
          <img
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              `/${PINNED_ASSET_SLUG}/page-headers/meta-rating-page/meta-rating-mobile.png`
            }
            alt={t("hero.alt")}
            className={cn("block h-[312px] w-auto object-cover object-left")}
          />
          <div className="flex flex-col justify-center p-4 gap-y-1 min-h-[120px] absolute bottom-0">
            <div className="text-sm font-semibold text-dark-primary">
              <Trans
                ns="metaRating"
                i18nKey="hero.title"
                components={{ br: <br /> }}
              />
            </div>
            <div className="text-xs text-dark-tertiary max-w-[350px]">
              {t("hero.description")}
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-new-gray-900">
          <img
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              `/${PINNED_ASSET_SLUG}/page-headers/meta-rating-page/meta-rating-desktop.png`
            }
            alt={t("hero.alt")}
            className="mx-auto touch-device:h-[228px] object-center object-cover"
          />
        </div>
      )}
      {isTouch && (
        <div className="flex-col justify-center p-4 bg-[#14191F] min-h-[120px] hidden touch-device:flex ">
          <span className="text-sm font-semibold text-dark-primary">
            <Trans
              ns="metaRating"
              i18nKey="hero.title"
              components={{ br: <br /> }}
            />
          </span>
          <span className="max-w-[400px] text-xs text-dark-tertiary">
            {t("hero.description")}
          </span>
        </div>
      )}

      <MetaRatingInfoBanner />
      <div className="w-full max-w-content mx-auto">
        <MetaRatingComparison />
      </div>
    </div>
  );
};

export default MetaRatingLandingPage;
